import Api from './Api';

const END_POINT = 'brands';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    },
    store(brand) {
        return Api.post(`${END_POINT}`, brand);
    },
    update(brand) {
        return Api.patch(`${END_POINT}/${brand.id}`, brand);
    },
    change_status(brand) {
        return Api.patch(`${END_POINT}/${brand.id}/change-status`, brand);
    },
}